import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 取鄉鎮市
 */
const GetSubJobTitleCodeList = [
    'POST',
    RouteUrlList.API_GetSubJobTitle.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: '',

        data: [
            {
                enum_type: 'jobtitle',
                enum_id: '81',
                enum_nm: '行政及文書事務人員',
                enum_desc: '1'
            }
        ]
    }
];
export default GetSubJobTitleCodeList;
